import { Alert, AlertDescription, AlertTitle } from '@tempo-io/sui-alert';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { formatNumber } from '@/common/utils/formatNumber';
import type { ItemLimit } from './types';

interface PublishedTruncationAlertProps {
  itemLimit?: ItemLimit;
}

export function PublishedTruncationAlert({ itemLimit }: PublishedTruncationAlertProps) {
  const { t } = useTranslation();
  const [dismissed, setDismissed] = useState(false);

  if (!itemLimit?.truncated || dismissed) return null;

  return (
    <Alert
      variant="warning"
      data-testid="published-truncation-warning"
      onDismiss={() => setDismissed(true)}
    >
      <AlertTitle>{t(($) => $.views.published.truncationWarning.title)}</AlertTitle>
      <AlertDescription>
        {t(($) => $.views.published.truncationWarning.description, {
          limit: formatNumber(itemLimit.limit),
        })}
      </AlertDescription>
    </Alert>
  );
}
